// extracted by mini-css-extract-plugin
module.exports = {"manuals_container":"input_manuals_container__1wLqt","manual":"input_manual__3JeVY","imgContainer":"input_imgContainer__211YS","info":"input_info__20Ddf"};